<template>
    <div class="rate-table">
        <form-field-messages :messages="{ error }" v-if="error"/>
        <div class="rate-table--content" v-else>
            <div class="rate-table--wrapper" v-if="tableData">
                <form @submit.prevent="filter">
                    <fieldset>
                        <div class="rate-table--filters">
                            <div class="rate-table--filter rate-table--filter__export">
                                <a class="rate-table--link" download :href="tableData.export_link">
                                    <ui-icon symbol="download" size="medium"/>
                                    <span class="rate-table--link-label">
                                        {{ tableData.options.texts.export_link_label }}
                                    </span>
                                </a>
                            </div>
                            <div class="rate-table--filter rate-table--filter__search">
                                <ui-input :placeholder="tableData.options.texts.search_input_placeholder"
                                        :facets="['base', 'large']"
                                        @input="search">
                                    <span slot="label">
                                        {{ tableData.options.texts.search_input_label }}
                                    </span>
                                </ui-input>
                            </div>
                            <div class="rate-table--filter rate-table--filter__dropdown">
                                <ui-select :facets="['base', 'large']"
                                        :value="tableData.categories[0]"
                                        @change="filterCategory">
                                    <span slot="label">
                                        {{ tableData.options.texts.dropdown_label }}
                                    </span>
                                    <ui-option v-for="(category, index) in tableData.categories" :key="index">
                                        {{ category }}
                                    </ui-option>
                                </ui-select>
                            </div>
                            <div class="rate-table--filter rate-table--filter__checkbox">
                                <ui-checkbox :facets="['base', 'multiline']" @change="onToggleRateDiff">
                                    <span slot="label">
                                        {{ tableData.options.texts.checkbox_label }}
                                    </span>
                                </ui-checkbox>
                            </div>
                        </div>
                    </fieldset>
                </form>
                <!-- this plugin is installed via Vue.use(ClientTable) -->
                <v-client-table v-bind="tableData" ref="table">
                    <tr slot="beforeFilters">
                        <th v-for="(column, index) in tableData.subcolumns" :key="index">
                            {{ column }}
                        </th>
                    </tr>
                </v-client-table>
            </div>

            <div class="rate-table--loader" v-else>
                <spinning-loader/>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'util/service';
    import { Event } from 'vue-tables-2';
    import UiIcon from '@dreipol/vue-ui/src/components/icon/icon.vue';
    import UiSelect from '@dreipol/vue-ui/src/components/form/select/select.vue';
    import UiOption from '@dreipol/vue-ui/src/components/form/option/option.vue';
    import UiInput from '@dreipol/vue-ui/src/components/form/input/input.vue';
    import UiCheckbox from '@dreipol/vue-ui/src/components/form/checkbox/checkbox.vue';
    import SpinningLoader from 'framework/components/loaders/spinning-loader/spinning-loader';
    import FormFieldMessages from 'framework/components/form/form-field-messages/form-field-messages';

    const YEARLY_RATE_DIFFERENCE_FILTER_ID = 'yearly_rate_difference';
    const VUE_TABLES_FILTER_PREFIX = 'vue-tables.filter::';

    export default {
        components: { FormFieldMessages, SpinningLoader, UiSelect, UiOption, UiInput, UiCheckbox, UiIcon },
        props: {
            url: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                error: null,
                activeFilters: {
                    category: '',
                    description: '',
                },
                tableData: null,
            };
        },
        methods: {
            filterCategory(event) {
                const { value, selectedIndex } = event.target;
                const isFirstElement = selectedIndex === 0;

                this.activeFilters.category = isFirstElement ? '' : value;

                this.filter();
            },
            onToggleRateDiff(event) {
                Event.$emit(`${ VUE_TABLES_FILTER_PREFIX }${ YEARLY_RATE_DIFFERENCE_FILTER_ID }`, event.target.checked);
            },
            filterByYearlyRateDifference(row, isFilterActive) {
                /* eslint-disable camelcase */
                if (!isFilterActive) {
                    return true;
                }

                const { ARF_previous_year_incl, ARF_previous_year_excl, ARF_current_year_incl, ARF_current_year_excl } = row;


                return ARF_previous_year_incl - ARF_previous_year_excl !== ARF_current_year_incl - ARF_current_year_excl;
                /* eslint-enable camelcase */
            },
            search(event) {
                const { value } = event.target;

                this.activeFilters.description = value;

                this.filter();
            },
            filter() {
                this.$refs.table.setFilter(this.activeFilters);
            },
        },
        mounted() {
            axios
                .get(this.url)
                .then(({ data }) => {
                    data.options.customFilters = [{
                        name: YEARLY_RATE_DIFFERENCE_FILTER_ID,
                        callback: this.filterByYearlyRateDifference,
                    }];

                    this.tableData = data;
                })
                .catch(error => {
                    this.error = [error];
                });
        },
    };
</script>
